<div class="flex flex-col gap-3">
  @switch (step()) {
    @case (TakeDepositStep.Capture) {
      <h3 class="!m-0 !font-bold">
        Take the {{ formattedAmount() }} deposit payment.
      </h3>
      @if (captureData(); as data) {
        <pr-appointment-deposit-capture
          [data]="data"
          (captured)="captureCompleted($event)"
          (back)="leaveCapture()"
        />
      }
    }
    @case (TakeDepositStep.Channels) {
      <h3 class="!m-0 !font-bold">
        Send the patient a link to pay the {{ formattedAmount() }} deposit.
      </h3>
      <div class="flex flex-col gap-2">
        <button
          mat-flat-button
          color="primary"
          aria-label="Send deposit payment link by email"
          [disabled]="busy()"
          (click)="sendLink(DepositRequestDeliveryChannel.Email)"
        >
          <span class="flex items-center justify-center gap-2">
            <mat-icon>email</mat-icon>
            <span>Email</span>
          </span>
        </button>
        <button
          mat-flat-button
          color="primary"
          aria-label="Send deposit payment link by SMS"
          [disabled]="busy()"
          (click)="sendLink(DepositRequestDeliveryChannel.SMS)"
        >
          <span class="flex items-center justify-center gap-2">
            <mat-icon>sms</mat-icon>
            <span>SMS</span>
          </span>
        </button>
      </div>
      <div class="flex justify-start">
        <button
          mat-stroked-button
          aria-label="Back to deposit options"
          [disabled]="busy()"
          (click)="showMethods()"
        >
          <mat-icon>arrow_back</mat-icon>
          Back
        </button>
      </div>
    }
    @default {
      <h3 class="!m-0 !font-bold">
        How would you like to take the {{ formattedAmount() }} deposit?
      </h3>
      <div class="flex flex-col gap-2">
        <button
          mat-flat-button
          color="primary"
          aria-label="Take payment in person"
          [disabled]="busy()"
          (click)="recordDeposit()"
        >
          <span class="flex items-center justify-center gap-2">
            @if (recording()) {
              <mat-spinner diameter="20" />
            } @else {
              <mat-icon>attach_money</mat-icon>
            }
            <span>Take payment in person</span>
          </span>
        </button>
        <button
          mat-flat-button
          color="primary"
          aria-label="Send payment link"
          [disabled]="busy()"
          (click)="showChannels()"
        >
          <span class="flex items-center justify-center gap-2">
            <mat-icon>link</mat-icon>
            <span>Send payment link</span>
          </span>
        </button>
        <div class="mt-1 flex flex-col gap-1 border-t border-gray-200 pt-3">
          @if (mustDecide()) {
            <button
              mat-stroked-button
              aria-label="Skip for now"
              [disabled]="busy()"
              (click)="skip()"
            >
              <span class="flex items-center justify-center gap-2">
                <mat-icon>schedule_send</mat-icon>
                <span>Skip for now</span>
              </span>
            </button>
            <span class="text-center text-xs text-gray-600">
              The deposit will still need to be collected before the
              appointment.
            </span>
          } @else {
            <button
              mat-stroked-button
              aria-label="Cancel"
              [disabled]="busy()"
              (click)="skip()"
            >
              Cancel
            </button>
          }
        </div>
      </div>
    }
  }
</div>
